import { useEffect, useState, useCallback } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import API, { getImageUrl } from '../utils/api';
import Footer from '../components/Footer';
import LanguageSwitcher from '../components/LanguageSwitcher';

const BlogDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [translated, setTranslated] = useState(null);

  useEffect(() => {
    API.get(`/blogs/${id}`).then(r => {
      setBlog(r.data);
      setTranslated({ title: r.data.title, content: r.data.content, excerpt: r.data.excerpt });
      setLoading(false);
      window.scrollTo(0, 0);
    }).catch(() => {
      setLoading(false);
    });
  }, [id]);

  const handleTranslated = useCallback((data) => {
    setTranslated(data);
  }, []);

  if (loading) return <div className="loading"><div className="spinner" /></div>;
  if (!blog) return (
    <div style={{ paddingTop: 120, textAlign: 'center', padding: '120px 5%' }}>
      <h2>Article not found</h2>
      <button className="btn-outline" onClick={() => navigate(-1)} style={{ marginTop: 20, cursor: 'pointer' }}>← Go Back</button>
    </div>
  );

  const formatDate = (d) => new Date(d).toLocaleDateString('en-US', { 
    year: 'numeric', month: 'long', day: 'numeric' 
  });

  const display = translated || blog;

  return (
    <div>
      <div className="blog-detail">
        <button 
          onClick={() => navigate(-1)} 
          style={{ 
            display: 'flex', alignItems: 'center', gap: 8,
            background: 'none', border: 'none', cursor: 'pointer',
            color: 'var(--warm-gray)', fontSize: '0.9rem', marginBottom: 32,
            fontFamily: 'Jost, sans-serif', fontWeight: 500,
            transition: 'color 0.3s'
          }}
          onMouseEnter={e => e.target.style.color = 'var(--forest)'}
          onMouseLeave={e => e.target.style.color = 'var(--warm-gray)'}
        >
          ← Back
        </button>

        {blog.image && (
          <img src={getImageUrl(blog.image)} alt={blog.title} className="blog-detail-hero" />
        )}

        <div style={{ marginBottom: 12 }}>
          <span style={{ 
            fontSize: '0.75rem', fontWeight: 500, letterSpacing: '0.15em',
            textTransform: 'uppercase', color: 'var(--gold-dark)',
            padding: '4px 12px', border: '1px solid var(--gold)',
            background: 'rgba(201,168,76,0.08)'
          }}>
            {blog.page}
          </span>
        </div>

        <h1 className="blog-detail-title">{display.title}</h1>

        <div className="blog-detail-meta">
          <span style={{ fontSize: '0.85rem', color: 'var(--warm-gray)' }}>
            By {blog.author}
          </span>
          <span style={{ color: 'var(--light-border)' }}>•</span>
          <span style={{ fontSize: '0.85rem', color: 'var(--warm-gray)' }}>
            {formatDate(blog.createdAt)}
          </span>
          {blog.tags?.length > 0 && (
            <>
              <span style={{ color: 'var(--light-border)' }}>•</span>
              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                {blog.tags.map(tag => (
                  <span key={tag} style={{ 
                    fontSize: '0.75rem', padding: '2px 10px',
                    background: 'var(--cream-dark)', color: 'var(--warm-gray)',
                    borderRadius: '20px'
                  }}>{tag}</span>
                ))}
              </div>
            </>
          )}
        </div>

        {/* Language Switcher */}
        <LanguageSwitcher article={blog} onTranslated={handleTranslated} />

        <div 
          className="blog-detail-content"
          dangerouslySetInnerHTML={{ __html: display.content }}
        />

        {blog.importantLinks?.length > 0 && (
          <div className="important-links">
            <h3>📌 Important Links & Resources</h3>
            <ul className="important-links-list">
              {blog.importantLinks.map((link, i) => (
                <li key={i}>
                  <a href={link.url} target="_blank" rel="noreferrer">
                    <span style={{ color: 'var(--gold)', fontSize: '1rem' }}>→</span>
                    {link.label || link.url}
                    <span style={{ marginLeft: 'auto', fontSize: '0.75rem', color: 'var(--warm-gray)' }}>↗</span>
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
};

export default BlogDetail;
